import { render } from "./CLoading.vue?vue&type=template&id=6bfe2863&scoped=true"
const script = {}

import "./CLoading.vue?vue&type=style&index=0&id=6bfe2863&lang=scss&scoped=true"

import exportComponent from "../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfe2863"]])

export default __exports__